module.exports = __webpack_public_path__ + "img/buyNow.9dea3b06.jpg";